// extracted by css-extract-rspack-plugin
export default {"root":"_vroqD","llama-part":"Sb2Pib","llamaPart":"Sb2Pib","llama-icon":"ZvhTJr","llamaIcon":"ZvhTJr","llama-text":"NPTdFD","llamaText":"NPTdFD"};